export const security = {
  'if-you-donot-have-patranomic': 'Եթե հայրանուն չունեք, դրեք գծիկ',
  citizenship: 'Քաղաքացիություն',
  'email-results': 'Ստուգման արդյունքում Ձեր <strong>{userEmail}</strong> էլ․ հասցեին կուղարկվի նամակ',
  'store-manager': 'Խանութի տնօրեն',
  'security-questionnaire': 'Ներքին հարցաթերթիկ',
  'acceptable-formats': 'Թույլատրելի ձևաչափերը — .jpeg, .jpg, .png, .pdf',
  'download-file-before-sending': 'Ներբեռնեք ֆայլ(եր)ը նախքան ուղարկելը',
  'field-too-long': 'Ամենաշատը 255 նիշ',
};
